import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling-light';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "MailFunctionalBoot" */ './lazyIndex'),
    { name: 'MailFunctionalBoot' }
);

export const lazySetupMailModulePostRender: LazyAction<
    typeof lazyIndex.setupMailModulePostRender,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setupMailModulePostRender);
